import { element } from "protractor";
import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { GestorConviteCadastro } from "src/app/models/gestor-convite-cadastro";
import { MASKS, NgBrazilValidators } from "ng-brazil";
import {
    FormBuilder,
    FormGroup,
    FormControl,
    Validators
} from "@angular/forms";
import { GestorService } from "src/app/services/gestor.service";
import { AuthenticationService } from "src/app/services/authentication.service";
import { PerfilService } from "src/app/services/perfil.service";
import { Auth } from "src/app/models/auth";
import { Perfil } from "src/app/models/perfil";
import { PerfilNormalizado } from "src/app/shared/enums/perfil-normalizado.enum";
import { ApiError } from "src/app/shared/enums/api-error.enum";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { GenericValidator } from "src/app/shared/validators/generic-validator.validator";
import { ParametrosDataService } from "src/app/services/parametros-data.service";
import { ParametrosKey } from "src/app/shared/enums/parametros.enum";
import { Router, ActivatedRoute } from '@angular/router';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';

@Component({
    selector: "app-gestor-invite",
    templateUrl: "./gestor-invite.component.html",
    styleUrls: ["./gestor-invite.component.css"]
})
export class GestorInviteComponent implements OnInit {
    constructor(
        private formBuilder: FormBuilder,
        private gestorService: GestorService,
        private authenticationService: AuthenticationService,
        private alertService: NewAlertService,
        private perfilService: PerfilService,
        private modalService: NgbModal,
        private router: Router,
        private route: ActivatedRoute,
        private parametrosDataService: ParametrosDataService
    ) { }

    public InNameHasNumber: boolean;
    public MASKS = MASKS;
    public gestorConviteFormGroup: FormGroup;
    private currentUser: Auth;
    gestorConviteCadastro: GestorConviteCadastro;

    public perfisList: Perfil[];
    perfilSelected: boolean;
    arraySelect: number[];

    perfilCadastroLabel = "Cadastro";
    gestorLabel = "Gestor";

    public senhaGestor = "";
    @ViewChild("senhaGestorModal", { static: true })
    senhaGestorModal: TemplateRef<any>;
    @ViewChild("modalSucesso", { static: true }) modalSucesso: TemplateRef<any>;
    @ViewChild("modalInsucesso", { static: true }) modalInsucesso: TemplateRef<any>;

    ngOnInit() {
        this.currentUser = this.authenticationService.currentUserValue;
        this.loadLists();
        this.createForm(new GestorConviteCadastro("", "", "", "", null));
        this.InNameHasNumber = false;
    }

    public get form() {
        return this.gestorConviteFormGroup.controls;
    }

    private loadLists() {
        this.perfilService.getAllPerfil().subscribe(response => {
            if (response.status === ApiError.Sucesso) {
                this.perfisList = response.result.filter(
                    x => x.nomeNormalizado !== PerfilNormalizado.Responsavel
                );
                this.loadViewConfig();
            } else {
                this.alertService.error(response.message);
            }
        });
    }

    loadViewConfig() {
        const parametros = this.parametrosDataService.currentParametrosValue;
        if (parametros) {
            if (parametros[ParametrosKey.perfisPermitidosConviteGestor]) {
                const perfisPermitidos = [];
                parametros[ParametrosKey.perfisPermitidosConviteGestor].forEach(
                    element => {
                        perfisPermitidos.push(
                            this.perfisList.find(x => x.perfilId === element)
                        );
                    }
                );

                if (
                    parametros[
                    ParametrosKey.labelPersonalizadaNomePerfilCadastro
                    ]
                ) {
                    const perfilCadastro = perfisPermitidos.find(
                        x => x.nome === "Cadastro"
                    );
                    if (perfilCadastro) {
                        perfilCadastro.nome =
                            parametros[
                            ParametrosKey.labelPersonalizadaNomePerfilCadastro
                            ];
                    }
                }

                this.perfisList = perfisPermitidos;
            }
            if (parametros[ParametrosKey.labelPersonalizadaGestor]) {
                this.gestorLabel =
                    parametros[ParametrosKey.labelPersonalizadaGestor];
            }
        }
    }

    goToBack() {
        this.router.navigate(['../list'], { relativeTo: this.route });
    }

    private createForm(gestorConviteCadastro: GestorConviteCadastro) {
        this.gestorConviteFormGroup = this.formBuilder.group({
            nome: new FormControl(gestorConviteCadastro.nome, [
                Validators.required,
                Validators.minLength(3),
                Validators.maxLength(100)
            ]),
            cpf: new FormControl(gestorConviteCadastro.cpf, [
                Validators.required,
                NgBrazilValidators.cpf
            ]),
            email: new FormControl(gestorConviteCadastro.email, [
                Validators.required,
                Validators.email
            ])
        });
    }

    showModal(content: any) {
        this.modalService.open(content, { centered: true, size: "lg" });
    }

    isChecked() {
        this.perfilSelected = null;
        this.arraySelect = [];
        this.perfisList.forEach(obj => {
            if (obj.selected) {
                this.arraySelect.push(obj.perfilId);
                this.perfilSelected = true;
            }
        });
        if (this.perfilSelected !== true) {
            this.perfilSelected = false;
        }
    }

    InNameOnFocus() {
        this.InNameHasNumber = false;
    }

    InNameOnBlur(value: string) {
        if (!value) {
            return;
        }

        if (value.replace(/\D+/g, "").replace(" ", "").length > 0) {
            this.InNameHasNumber = true;
        } else {
            this.InNameHasNumber = false;
        }
    }

    onSubmit(gestorConviteCadastro: GestorConviteCadastro) {
        gestorConviteCadastro.perfisId = [];

        if (this.senhaGestor === "" && this.gestorConviteFormGroup.valid && this.perfilSelected) {
            this.showModal(this.senhaGestorModal);
        }

        if (
            this.gestorConviteFormGroup.valid &&
            this.perfilSelected &&
            this.senhaGestor !== "" &&
            !this.InNameHasNumber
        ) {
            gestorConviteCadastro.perfisId = this.arraySelect.slice(0);
            gestorConviteCadastro.cpf = gestorConviteCadastro.cpf
                .replace(/\D+/g, "")
                .replace(" ", "");
            gestorConviteCadastro.senhaGestor = this.senhaGestor;



            this.gestorService
                .invite(
                    gestorConviteCadastro,
                    this.currentUser.token.userReferenceId,
                    this.currentUser.token.assignorGuid
                )
                .subscribe(
                    response => {
                        if (response.status === ApiError.Sucesso) {
                            this.alertService.success(response.message);
                            this.createForm(
                                new GestorConviteCadastro("", "", "", "", null)
                            );
                            this.showModal(this.modalSucesso);
                        } else {
                            this.alertService.error(response.message);
                            this.showModal(this.modalInsucesso);
                            this.senhaGestor = "";
                        }
                    },
                    error => {
                        this.alertService.error('Ocorreu um erro ao buscar as informações!');
                        this.senhaGestor = "";
                    }
                );
        } else {
            this.isChecked();
            GenericValidator.verifierValidatorsForm(
                this.gestorConviteFormGroup
            );
        }
    }
}
